import React, { memo } from "react";
import Box from "@mui/material/Box";
import Skeleton from "react-loading-skeleton";

import AppSkeletonTheme from "../../../../components/skeletons/AppSkeletonTheme";

const sliderShellSx = {
  mb: 2.5,
  borderRadius: "16px",
  overflow: "hidden",
  bgcolor: "#fff",
  boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.08)",
  p: "10px",
  pb: 2.5,
} as const;

type SliderBlockProps = {
  className?: string;
  compact?: boolean;
};

/** Khối giả carousel + tiêu đề (không bọc SkeletonTheme). */
function PotsSliderBlock({ className, compact }: SliderBlockProps) {
  return (
    <Box
      className={className}
      sx={{
        ...sliderShellSx,
        minHeight: compact ? 140 : undefined,
      }}
    >
      <Box sx={{ textAlign: "center", mb: 1.5 }}>
        <Skeleton width="72%" height={22} style={{ margin: "0 auto 8px" }} />
        <Skeleton width="58%" height={22} style={{ margin: "0 auto" }} />
      </Box>
      <Skeleton height={compact ? 160 : 200} borderRadius={12} />
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          gap: 0.75,
          mt: 1.5,
        }}
      >
        <Skeleton circle width={8} height={8} />
        <Skeleton circle width={8} height={8} />
        <Skeleton circle width={8} height={8} />
      </Box>
    </Box>
  );
}

/** Chỉ vùng slider (khi `loadingSlider` trước khi có dữ liệu). */
export const PotsSliderSkeleton: React.FC<{ className?: string }> = memo(
  ({ className }) => (
    <AppSkeletonTheme borderRadius="12px">
      <PotsSliderBlock className={className} compact />
    </AppSkeletonTheme>
  )
);

PotsSliderSkeleton.displayName = "PotsSliderSkeleton";

/** Toàn trang pots khi `loadingPf` (chưa có product list). */
export const PotsPageCatalogSkeleton: React.FC = memo(() => (
  <AppSkeletonTheme borderRadius="12px">
    <Box
      sx={{
        marginTop: { xs: 0, sm: 2 },
        paddingBottom: 5,
        width: { xs: "100%", sm: "650px", md: "800px", lg: "981px" },
        maxWidth: "100%",
        boxSizing: "border-box",
      }}
    >
      <PotsSliderBlock />

      <Box
        sx={{
          px: { xs: 2, sm: 0 },
          width: "100%",
          maxWidth: "100%",
          boxSizing: "border-box",
          display: "grid",
          gridTemplateColumns: {
            xs: "repeat(2, minmax(0, 1fr))",
            sm: "repeat(3, minmax(0, 1fr))",
            md: "repeat(4, minmax(0, 1fr))",
          },
          gap: { xs: 2, sm: 5 },
        }}
      >
        {Array.from({ length: 8 }).map((_, i) => (
          <Box
            key={i}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "stretch",
              minWidth: 0,
              width: "100%",
            }}
          >
            <Box
              sx={{
                width: "100%",
                maxWidth: { xs: "100%", sm: "190px", md: "180px", lg: "215px" },
              }}
            >
              <Skeleton
                height={170}
                borderRadius="10px"
                style={{ width: "100%" }}
              />
              <Skeleton
                width="88%"
                height={14}
                style={{ marginTop: 10 }}
              />
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  </AppSkeletonTheme>
));

PotsPageCatalogSkeleton.displayName = "PotsPageCatalogSkeleton";
